export default "__VITE_ASSET__DVyuE_J4__"